import React from 'react';
import { Box, Grid, IconButton } from '@mui/material';
import { SubFunctionAuxiliaryHint } from '../rbp-cloud-sub-function/sub-function-auxiliary-hint.component';
import Card from '../dish-menu-creator/Card';
import { FirstMenu, MenuDish } from '../../models';
import apiManage, { apiManage_rbp } from '../../request';
import _ from 'lodash';
import setLoading from '../../component/linear-determinate';
import GlobalNotification from '../../component/common/snackbar';
import LSM from '../../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';
import { getRBPStringId } from '../main/main-page-states';
import { FirstScreenBundledContext, type FirstScreenBundledContextValue } from './first-screen-bundled-context';
import { getRecommendDishBundledAvatarUrls } from '../../utils/restaurant-static-bundled';
import AlertDialog from '../../component/dialog/alert-dialog.component';
import { RestaurantStaticImageUpload } from '../../component/restaurant-static-image-upload.component';
import { Close } from '@mui/icons-material';
import i18n from '../../i18n';
import MenuDishList from '../dish-menu-creator/menu-dish-list/menu-dish-list';
import { FirstScreenMediaCardHeader } from './first-screen-media-card-header.component';
import { tFirstScreenCardTitleWithSuggestedImageSize } from './first-screen-card-title-i18n';

/** 推荐菜品标题区「已选/上限」上限，与 Figma 1838:52035 稿面 4/6 展示一致（业务上仅作展示上限） */
const RECOMMEND_DISH_DISPLAY_MAX = 6;

/**
 * 为 `dish_image` 完整 URL 附加缓存破坏参数（与 `restaurant-static-bundled.withImageCacheBust` 行为一致）。
 */
function bustDishImageDisplayUrl(url: string, bust: number): string | undefined {
    const u = String(url || '').trim();
    if (!u) {
        return undefined;
    }
    const sep = u.includes('?') ? '&' : '?';
    return `${u}${sep}cb=${encodeURIComponent(String(bust))}`;
}
class SpecialDishes extends React.Component<Props, State> {
    /** 首页 bundled：用于推荐菜预览 URL */
    public static contextType = FirstScreenBundledContext;

    /**
     * React 注入的 Context（避免 `declare context` 导致 CRA Babel 构建失败）。
     */
    private get bundledPageContext(): FirstScreenBundledContextValue | null {
        return (this as unknown as { context: FirstScreenBundledContextValue | null }).context;
    }

    /** 从缓存中拿服务器地址（bundled 无单品预览时的回退） */
    public SERVER_URL = LSM.get(LOCAL_STORAGE_KEYS.SERVER_URL);
    public MenuDishListRefs: MenuDishList | null = null;
    public state: State = {
        // 新增特色菜弹窗
        isAddDishDialogOpen: false,
        // 所有菜品列表
        menuData: [],
        // 特色菜数据
        specialDishes: [],
        // 删除弹窗开关
        deleteOpen: false,
        // 刷新图片（bundled 回退路径用）
        randomId: Math.random()
    }

    // *********************
    // Life Cycle Function
    // *********************

    componentDidMount() {
        this.init()
    }

    // *********************
    // Default Function
    // *********************

    /**
     * 初始化
     */
    init() {
        this.getSpecialDishes();
        this.getMenuData();
    }

    /**
     * 获取特色菜单
     */
    public async getSpecialDishes() {
        const result = await apiManage_rbp.get_special_dishes();
        if (!_.get(result, 'error')) {
            this.setState({
                specialDishes: result
            })
        }
        else {
            return []
        }
    }

    /**
     * 获取菜单
     */
    public async getMenuData() {
        const result = await apiManage_rbp.get_menus_v3({
            type: 0,
            with_dish: true,
        })
        if (!_.get(result, 'error')) {
            this.setState({
                menuData: result
            })
        }

    }

    /**
     * 删除一个特色菜单
     */
    async handleDeleteDish() {
        try {
            setLoading(true);
            const result = await apiManage_rbp.del_special_dishes(`${this.state.deleteId || ''}`);
            if (!result.error) {
                await this.getSpecialDishes();
                GlobalNotification.success(i18n.t('google_text_delete_success'))
            } else {
                GlobalNotification.error(i18n.t('google_text_delete_failed'))
            }
            setLoading(false);
        } catch (error) {

        }
    }

    filterDish(dishes: MenuDish[]) {
        const dishIds: number[] = [];
        for (const i in dishes) {
            if (!dishes[i].menu_item_id) {
                dishIds.push(dishes[i].menu_item_id || 0)
                continue;
            }
        }
        return dishIds;
    }

    /**
     * 添加特色菜
     */
    async addDish(id: number) {
        try {
            await apiManage_rbp.post_special_dishes(id);
        } catch (error) {

        }
    }


    /**
     * 上传推荐菜关联的菜品图（v1 `dish-image`，大图与小图各传一次同一文件）。
     * @param id - `menu_item_id` 字符串
     * @param file - 图片文件
     */
    async onChangeMenuDefault(id: string, file: File) {
        if (!id) {
            return;
        }
        const sid = getRBPStringId();
        const mainName = `${id}.jpg`;
        const smallName = `${id}_s.jpg`;
        const r1 = await apiManage.post_restaurant_static_dish_image(sid, file, mainName);
        if (_.get(r1, 'error')) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_modify_dish_picture_failed'));
            return;
        }
        const r2 = await apiManage.post_restaurant_static_dish_image(sid, file, smallName);
        if (_.get(r2, 'error')) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_modify_dish_picture_failed'));
            return;
        }
        GlobalNotification.success(i18n.t('menu_and_dishes_page_modify_dish_picture_succeed'));
        await this.bundledPageContext?.reloadBundled();
        this.setState({ randomId: Math.random() });
    }

    /**
     * 删除推荐菜关联的菜品展示图（按文件名删大图与小图）。
     * @param menuItemId - 菜品 menu_item_id
     */
    async deleteImage(menuItemId: string | number) {
        if (menuItemId === '' || menuItemId === undefined || menuItemId === null) {
            return;
        }
        const sid = getRBPStringId();
        const id = String(menuItemId);
        const r1 = await apiManage.delete_restaurant_static_dish_image(sid, `${id}.jpg`);
        const r2 = await apiManage.delete_restaurant_static_dish_image(sid, `${id}_s.jpg`);
        const failed = Boolean(_.get(r1, 'error')) && Boolean(_.get(r2, 'error'));
        if (failed) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
            return;
        }
        GlobalNotification.success(i18n.t('global_text_operate_success'));
        await this.bundledPageContext?.reloadBundled();
        this.setState({ randomId: Math.random() });
    }

    // ***************
    // VIEW
    // ***************

    render() {
        const { menuData, isAddDishDialogOpen, specialDishes, deleteOpen, randomId } = this.state;
        const bust = this.bundledPageContext?.bustVersion ?? randomId;
        /** 云 RBP 子功能顶栏「辅助模式」 */
        const auxiliaryModeEnabled = this.props.auxiliaryModeEnabled === true;
        const bundled = this.bundledPageContext?.bundled;
        return (
            <div>
                <Card
                    className={'common-card'}
                    title={(
                        <Box sx={{ width: '100%' }}>
                            <FirstScreenMediaCardHeader
                                title={tFirstScreenCardTitleWithSuggestedImageSize(
                                    'menu_and_dishes_page_recommend_dish_select',
                                )}
                                usedCount={specialDishes.length}
                                totalCount={RECOMMEND_DISH_DISPLAY_MAX}
                            />
                            <SubFunctionAuxiliaryHint
                                enabled={auxiliaryModeEnabled}
                                i18nKey="first_screen_aux_recommend_dishes"
                            />
                        </Box>
                    )}
                    contentRender={(
                        <Grid container spacing={3}>
                            {
                                specialDishes.map((item) => {
                                    const mid = `${item.menu_item_id || ''}`;
                                    const fromBundled =
                                        bundled && mid
                                            ? getRecommendDishBundledAvatarUrls(bundled, mid, bust)
                                            : {};
                                    const base = String(this.SERVER_URL || '').replace(/\/+$/, '');
                                    /** `GET v2/special_dishes/{stringId}` 行内 `dish_image`（完整 URL），无 bundled 扩展时作展示主来源 */
                                    const dishImageFromApi = String(item.dish_image ?? '').trim();
                                    const fromApiBusted = dishImageFromApi
                                        ? bustDishImageDisplayUrl(dishImageFromApi, Number(bust))
                                        : undefined;
                                    const avatarUrl =
                                        fromBundled.avatarUrl ??
                                        fromApiBusted ??
                                        (base ? `${base}/${mid}_s.jpg?randomId=${randomId}` : undefined);
                                    const avatarUrlMax =
                                        fromBundled.avatarUrlMax ??
                                        fromApiBusted ??
                                        (base ? `${base}/${mid}.jpg?randomId=${randomId}` : undefined);
                                    return (
                                    <Grid item key={item.id}>
                                        <div className='check-box-avatar'>
                                            <div className='check-box-btn'>
                                                <IconButton
                                                    className='check-box-icon'
                                                    size='small'
                                                    onClick={() => {
                                                        this.setState({
                                                            deleteId: item.id,
                                                            deleteOpen: true,
                                                        })
                                                    }}>
                                                    <Close />
                                                </IconButton>
                                            </div>
                                            <RestaurantStaticImageUpload
                                                stringId={getRBPStringId()}
                                                kind="dish-image"
                                                uploadEntityId={1}
                                                deferStaticUpload
                                                imageRef={avatarUrl || avatarUrlMax ? mid : ''}
                                                displayUrl={avatarUrl ?? ''}
                                                displayUrlMax={avatarUrlMax ?? avatarUrl ?? ''}
                                                avatarLabel={item.item_name1}
                                                onStagedStaticFile={async (file) => {
                                                    await this.onChangeMenuDefault(mid, file);
                                                }}
                                                onDeferredStaticRemove={async () => {
                                                    await this.deleteImage(mid);
                                                }}
                                                uploadEmptyVariant="firstScreenGallery"
                                                slotWidth={256}
                                                slotHeight={160}
                                                sx={{ minHeight: 160 }}
                                            />
                                        </div>
                                    </Grid>
                                    );
                                })
                            }
                            {specialDishes.length < RECOMMEND_DISH_DISPLAY_MAX ? (
                                <Grid item key="special-dishes-add-slot">
                                    <RestaurantStaticImageUpload
                                        stringId={getRBPStringId()}
                                        kind="dish-image"
                                        uploadEntityId={1}
                                        deferStaticUpload
                                        imageRef=""
                                        displayUrl=""
                                        uploadEmptyVariant="firstScreenGallery"
                                        slotWidth={256}
                                        slotHeight={160}
                                        sx={{ minHeight: 160 }}
                                        emptyUploadLabel={i18n.t('first_screen_text_add_dish')}
                                        onGalleryEmptyClick={() => {
                                            this.MenuDishListRefs?.clearSelected();
                                            this.setState({ isAddDishDialogOpen: true });
                                        }}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>
                    )}
                />

                <MenuDishList
                    ref={(refs) => { this.MenuDishListRefs = refs }}
                    isShowPackage={true}
                    menuData={menuData}
                    open={isAddDishDialogOpen}
                    filterDishArr={this.filterDish(specialDishes)}
                    onCancel={() => {
                        this.setState({
                            isAddDishDialogOpen: false
                        })
                    }}
                    onConfirm={(ids, items) => {
                        console.log(ids, items)
                        this.setState({
                            isAddDishDialogOpen: false
                        }, async () => {
                            setLoading(true);
                            /** 本地特价菜仅接受有效数字 item_id */
                            for (const id of ids) {
                                if (typeof id === 'number' && id > 0) {
                                    await this.addDish(id);
                                }
                            }
                            await this.getSpecialDishes();
                            setLoading(false);
                        })

                    }}
                />
                {
                    deleteOpen &&
                    <AlertDialog
                        open={true}
                        variant="delete"
                        title={i18n.t('google_text_public_button_delete')}
                        onCancel={() => {
                            this.setState({
                                deleteOpen: false
                            })
                        }}
                        onConfirm={() => {
                            this.setState({
                                deleteOpen: false
                            }, () => {
                                this.handleDeleteDish()
                            })

                        }}
                    />
                }
            </div>
        )
    }
}

export default SpecialDishes;

// ***************
// TYPE
// ***************

type State = {
    // 所有菜品列表
    menuData: Array<FirstMenu>;
    // 新增特色菜弹窗
    isAddDishDialogOpen: boolean;
    // 特色菜数据
    specialDishes: Array<MenuDish>;
    // 删除弹窗开关
    deleteOpen: boolean;
    // 删除的菜品
    deleteId?: number;
    // 更新菜品图片
    randomId: number;
}

type Props = {
    /** 云 RBP 子功能壳顶栏「辅助模式」是否开启 */
    auxiliaryModeEnabled?: boolean;
};